
define(
	'Tavano.CatalogSegmentation.CatalogSegmentation'
	, [
		'SC.Configuration'
	]
	, function (
		Configuration
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
				var email = SC.ENVIRONMENT && SC.ENVIRONMENT.PROFILE && SC.ENVIRONMENT.PROFILE.email || '';
				var customfields = SC.ENVIRONMENT && SC.ENVIRONMENT.PROFILE && SC.ENVIRONMENT.PROFILE.customfields && SC.ENVIRONMENT.PROFILE.customfields || [];
				var internalId = SC.ENVIRONMENT && SC.ENVIRONMENT.PROFILE && SC.ENVIRONMENT.PROFILE.internalid || '';
				var isLoggedIn = SC.ENVIRONMENT && SC.ENVIRONMENT.PROFILE && SC.ENVIRONMENT.PROFILE.isLoggedIn || false;
				layout.addToViewContextDefinition('ItemRelations.RelatedItem.View', 'showItem', 'boolean', function (context) {
					if (isLoggedIn === 'T') {
						var includedItems = (context.model && context.model.custitem_tt_catalog_segmentation) || '';
						var showItem = includedItems.indexOf(stripEmail(email)) > -1;
						return showItem;
					} else {
						return true;
					}
				});
				var includedContacts = '';
				var segmentationContainerField = '';
				if (customfields.length) {
					segmentationContainerField = _.find(customfields, function (field) {
						return field.name === "custentity_tt_segmentation_container";
					});
				}
				if (segmentationContainerField) {
					includedContacts = segmentationContainerField.value;
				}
				if (email && includedContacts.indexOf(stripEmail(email)) > -1) {
					var strippedEmail = stripEmail(email);
					_.extend(Configuration.searchApiMasterOptions.Facets, {
						'custitem_tt_catalog_segmentation': strippedEmail + internalId
					});

					_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
						'custitem_tt_catalog_segmentation': strippedEmail + internalId
					});

					_.extend(Configuration.searchApiMasterOptions.typeAhead, {
						'custitem_tt_catalog_segmentation': strippedEmail + internalId
					});

					_.extend(Configuration.searchApiMasterOptions.relatedItems, {
						'custitem_tt_catalog_segmentation': strippedEmail + internalId
					});

					_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
						'custitem_tt_catalog_segmentation': strippedEmail + internalId
					});

					_.extend(Configuration.searchApiMasterOptions.itemDetails, {
						'custitem_tt_catalog_segmentation': strippedEmail + internalId
					});
				}
				function stripEmail(email) {
					var strippedEmail = _.map(email, function (char) {
						if (char !== '@' && char !== '.') {
							return char;
						}
						return '';
					}).join('');

					return strippedEmail;
				}
			}
		};
	});
